export default {
  xLarge: '2rem',
  large: '1.5rem',
  regular: '1.0rem',
  small: '0.8rem',
  lineXLarge: '1.8rem',
  lineLarge: '1.5rem',
  lineRegular: '1.2rem',
  lineSmall: '1rem',
};
